const initialState = {
	list: [],
	count: 0,
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_QA_ANSWER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.count = action.payload.count;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MY_QA_ANSWER_LIST_INIT') {
		return initialState;
	}
  else 	if (action.type === 'MY_QA_ANSWER_ITEM_SET') {
    let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let index = newState.list.findIndex((v) => v.question_id === action.payload.qaId);
			if (index >= 0) {
				newState.list.splice(index, 1);
				newState.count = newState.count - 1;
			}
		}
		return newState;
  }
	else {
		return state;
	}
}
